function OffersIcon() {
    return (
        <span className="anticon ant-menu-item-icon">
            <img src="/assets/images/Offers.svg" alt="Offers" width="24" height="24" />
        </span>
    );
}

export default OffersIcon;
